import { ref } from 'vue'
import { useRuntimeConfig } from '#app'
import { createSubmissionService } from '~/services/submission.service'
import { COURSE_CONFIG } from '~/config/course'
import type { Lesson } from '~/types/lesson.types'

const OSNOVY_TEACHER_ID = '6a8d6e1985858d4d47b1755a'

function generateStudyToken(lessonToken: string): string {
  const randomPart = Math.random().toString(36).slice(2, 9).toUpperCase()
  return `${lessonToken}-${randomPart}`
}

export function useSubmission() {
  const config = useRuntimeConfig()
  const { locale } = useI18n()
  const service = createSubmissionService(config.public.studentApi)

  const submitting = ref(false)
  const error = ref<string | null>(null)
  const success = ref(false)

  async function submitAndRedirect(payload: {
    name: string
    phone: string
    messenger: 'tg' | 'wa'
    lessonToken?: string
    lesson?: Lesson | null
    studyingResults?: Array<Record<string, unknown>>
  }) {
    submitting.value = true
    error.value = null
    try {
      if (payload.lesson) {
        const localeKey: 'uk' | 'ru' = locale.value === 'ru' ? 'ru' : 'uk'
        const courseConfig = COURSE_CONFIG[localeKey]
        await service.createPublicStudying({
          studying_token: generateStudyToken(payload.lesson.lesson_token),
          studying_missioner_id: OSNOVY_TEACHER_ID,
          studying_user_name: payload.name,
          studying_user_phone: payload.phone,
          studying_lesson_id: payload.lesson._id,
          studying_lesson_title: payload.lesson.lesson_title,
          studying_lesson_token: payload.lesson.lesson_token,
          studying_lesson_order: payload.lesson.lesson_order,
          studying_course_id: courseConfig.id,
          studying_course_title: COURSE_CONFIG.title,
          studying_course_token: courseConfig.token,
          account_id: COURSE_CONFIG.accountId,
          studying_results: payload.studyingResults ?? [],
          studying_params: { messenger_type: payload.messenger },
        })
      }

      success.value = true
    } catch (e) {
      error.value = e instanceof Error ? e.message : 'Submission failed'
    } finally {
      submitting.value = false
    }
  }

  return { submitting, error, success, submitAndRedirect }
}
